import { ConstructPost } from '../../../types/ConstructPost';
import { USER_BASE_PATH } from '../constants/userBasePath';

export const postRestoreUser = async (
  constructPost: ConstructPost,
  uuid: string,
): Promise<undefined> =>
  constructPost<undefined>(`${USER_BASE_PATH}/${uuid}/restore`, undefined, {
    preventDefaultErrorToast: true,
  });
